import { createStore } from 'vuex'
import dados from './dados'
import settings from './settings'
import token from './token'
import user from './user'

export default createStore({
    modules: {
        dados,
        settings,
        token,
        user,
    },
    state: {},
    mutations: {},
    actions: {},
    getters: {},
})
